import { IPaginationParams } from '../global/pagination';
import { ISortParams } from '../global/sort';

export interface ISentMessage {
  id: number;
  toPhoneNumber: string;
  data: string;
  type: string;
  preferredLocale: string;
  channel: string;
  sent: string;
  created: string;
  lastEventStatus: string;
}

export interface ISentMessageRequestParams extends IPaginationParams, ISortParams {
  channel?: string;
  toPhoneNumber?: string;
  journeyCode?: string;
  bookingCode?: string;
  createdBefore?: string;
  createdAfter?: string;
  includedStatuses?: string;
  excludedStatuses?: string;
}

export enum SentMessageType {
  DynamicPassword = 'DYNAMIC_PASSWORD',
  TravellerPrePickupOutbound =  'TRAVELLER_PRE_PICKUP_OUTBOUND',
  TravellerPrePickupInbound = 'TRAVELLER_PRE_PICKUP_INBOUND',
  DriverDelayed = 'DRIVER_DELAYED',
  BookerBookingPlaced = 'BOOKER_BOOKING_PLACED',
  SharedReturnPickupInfo = 'SHARED_RETURN_PICKUP_INFO',
  PhoneNumberVerification= 'PHONE_NUMBER_VERIFICATION',
  DriverDetails = 'DRIVER_DETAILS',
}

export const SentMessageTypeDisplayName = {
  [SentMessageType.DynamicPassword]: 'Dynamic password',
  [SentMessageType.TravellerPrePickupInbound]: 'Traveller pre-pickup inbound',
  [SentMessageType.TravellerPrePickupOutbound]: 'Traveller pre-pickup outbound',
  [SentMessageType.DriverDelayed]: 'Driver delayed',
  [SentMessageType.SharedReturnPickupInfo]: 'Return pickup info (shared)',
  [SentMessageType.BookerBookingPlaced]: 'Booker booking placed',
  [SentMessageType.PhoneNumberVerification]: 'Phone number verification',
  [SentMessageType.DriverDetails]: 'Driver details'
}

export enum SentMessageChannelType {
  SMS = 'SMS',
  WhatsApp = 'WHATSAPP',
}

export const SentMessageChannelTypeDisplayName = {
  [SentMessageChannelType.SMS]: 'SMS',
  [SentMessageChannelType.WhatsApp]: 'WhatsApp',
}

export enum LastEventStatusType {
  Accepted = 'ACCEPTED',
  Scheduled = 'SCHEDULED',
  Queued = 'QUEUED',
  Sending = 'SENDING',
  Sent = 'SENT',
  DeliveryUnknown = 'DELIVERY_UNKNOWN',
  Delivered = 'DELIVERED',
  Undelivered = 'UNDELIVERED',
  Failed = 'FAILED',
  Receiving = 'RECEIVING',
  Received = 'RECEIVED',
  Read = 'READ',
  Cancelled = 'CANCELED'
}

export const LastEventStatusTypeDipslayName = {
  [LastEventStatusType.Accepted]: 'Accepted',
  [LastEventStatusType.Scheduled]: 'Scheduled',
  [LastEventStatusType.Queued]: 'Queued',
  [LastEventStatusType.Sending]: 'Sending',
  [LastEventStatusType.Sent]: 'Sent',
  [LastEventStatusType.DeliveryUnknown]: 'Delivery unknown',
  [LastEventStatusType.Delivered]: 'Delivered',
  [LastEventStatusType.Undelivered]: 'Undelivered',
  [LastEventStatusType.Failed]: 'Failed',
  [LastEventStatusType.Receiving]: 'Receiving',
  [LastEventStatusType.Received]: 'Received',
  [LastEventStatusType.Read]: 'Read',
  [LastEventStatusType.Cancelled]: 'Cancelled',
}
